import { Link } from "react-router";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import MobileHeader from "./MobileHeader";
import { MobileContent } from "./MobileContent";
import { MobileBackButton } from "../misc/MobileBackButton";

export function MobileRecordState({
  loading,
  backTo,
  title,
  onRetry,
}: {
  loading: boolean;
  backTo: string;
  title: string;
  onRetry: () => void;
}) {
  return (
    <>
      <MobileHeader>
        <MobileBackButton to={backTo} />
      </MobileHeader>
      <MobileContent>
        {loading ? (
          <div
            role="status"
            aria-label="Загрузка карточки"
            className="space-y-4"
          >
            <Skeleton className="h-28 w-full" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-48 w-full" />
          </div>
        ) : (
          <div
            role="alert"
            className="rounded-3xl border bg-card p-5 space-y-4"
          >
            <h1 className="text-lg font-semibold">{title}</h1>
            <p className="text-sm text-muted-foreground">
              Запись недоступна или не найдена. Обновите данные или вернитесь к
              списку.
            </p>
            <div className="flex flex-wrap gap-2">
              <Button variant="outline" onClick={onRetry}>
                Попробовать снова
              </Button>
              <Button asChild variant="outline">
                <Link to={backTo}>К списку</Link>
              </Button>
            </div>
          </div>
        )}
      </MobileContent>
    </>
  );
}
